import MainLayout from '@/common/components/layouts/MainLayout';
import { QUERY_PARAMS } from '@/modules/FileDetail/FileDetailLinks';
import SendOfflinePhotos from '@/modules/OfflineFiles/components/SendOfflinePhotos';
import { useSearchParams } from 'react-router-dom';

const SendOfflinePhotosPage = () => {
  const [searchParams] = useSearchParams();
  const damagedId = searchParams.get(QUERY_PARAMS.sendOfflinePhotos);

  return (
    <MainLayout title="ارسال تصاویر" header="titleHeader">
      <SendOfflinePhotos damagedId={damagedId ?? undefined} />
    </MainLayout>
  );
};

export default SendOfflinePhotosPage;
